var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.994,
    height: 127.4,
    viewBox: "0 0 224.994 127.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M337.975,441.62s35.9,5.521,13.808,31.759-75.949,6.909-93.9-1.378-42.811-6.909-60.763,0-49.711-1.378-48.333-26.238,4.143-24.86-6.9-42.811-8.287-30.381,4.143-42.811",
    transform: "translate(-134.476 -359.787)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty4);
export default __webpack_public_path__ + "static/media/empty-4.a634e2e3fc2ed092deac4c7419d1f141.svg";
export { ForwardRef as ReactComponent };